<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->
</head>
<!-- Google Tag Manager (noscript) -->

<noscript>
    <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KB72W5J" height="0" width="0"
        style="display:none;visibility:hidden"></iframe>
</noscript>

<!-- End Google Tag Manager (noscript) -->
<div *ngIf="mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <!-- <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                            <tr>
                                <td >
                                    <audio controls>
                                        <source src="https://drive.google.com/uc?id=1QXZVxualw-zqGGP0d6DlAeLf7gHIIPsY&export=download"
                                            type="audio/mpeg">
                                        Your browser does not support the audio element.
                                    </audio><br /><br />
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align:center;">
                                    <i class="fa-solid fa-arrow-left fa-lg"></i>
                                </td>
                            </tr>
                        </div>
                    </td> -->
                    <td style="padding-left:4%;
                    padding-right:4%;
                    padding-top: 5%;
                    padding-bottom: 3%;">
                        <h1 style="color: #5ECE42">Method - Overview</h1><br />
                        An algorithm running on the Interactive Brokers (IBKR) platform can be designed to trade a
                        diversified
                        portfolio of assets from the S&P 500 index while incorporating various criteria, such as
                        timeframes, asset
                        types, trading styles, optimisation methods, and risk management techniques.
                        <br /><br />
                        <h2>Here's an overview of how such an algorithm can be implemented on the IBKR platform:</h2>

                        <br /><br />
                        <h3>Timeframe and Data Handling:</h3>
                        The algorithm operates on 4-hour bars, focusing on a medium-term timeframe. Using the IBKR API,
                        the
                        algorithm can access and process 4-hour historical and real-time bar data for the desired assets
                        from the
                        S&P 500 index. The API ensures seamless integration with the platform and provides the necessary
                        market
                        data.
                        <br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(1)" id="DailyCandles"><i class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h3>Asset Selection:</h3>
                        The algorithm trades a portfolio of the most liquid currencies, indices, and commodities within
                        the S&P 500
                        index. The IBKR platform offers access to a wide range of financial instruments within this
                        index. The
                        algorithm can use specific criteria, such as trading volume, bid-ask spread, or market
                        capitalisation, to
                        select the most liquid assets from each category.
                        <br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(2)" id="AbsoluteMomentum"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h3>Multiple Algorithm Components:</h3>
                        The algorithm incorporates 10 separate components that run in parallel, including five
                        trend-following and
                        five mean-reversion strategies. Each component targets different market conditions and price
                        patterns,
                        providing diversification and potentially enhancing the overall performance of the algorithm.
                        The IBKR API
                        enables the simultaneous execution of multiple trading strategies, allowing efficient management
                        of these
                        parallel components.
                        <br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(3)" id="RelativeMomentum"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h3>Rolling Window Walk-Forward Optimisation:</h3>
                        To optimise the algorithm, a rolling window walk-forward optimisation method is employed over a
                        7-year
                        period. This technique involves dividing the historical data into multiple in-sample and
                        out-of-sample
                        segments, iteratively training and testing the algorithm on these segments to fine-tune its
                        parameters. The
                        IBKR platform's backtesting capabilities support this optimisation process by providing
                        extensive historical
                        data and performance analysis tools.
                        <br /><br />
                        <div style="text-align: center">

                            <a (click)="subBub(4)" id="StockAndEtf"><i class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        <h3>Volatility-Adjusted Trade Exit Logic:</h3>
                        The algorithm uses volatility-adjusted trade exit logic, dynamically adjusting exit points based
                        on market
                        volatility. This approach helps protect profits and minimise losses during periods of high
                        market
                        volatility. The IBKR platform offers access to various volatility measures, such as the Average
                        True Range
                        (ATR) or historical volatility, which can be incorporated into the exit logic.
                        <br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(5)" id="LeveragedAndUnleveraged"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>

                        </div>
                        <br />
                        <h3>Capital Allocation and Position Sizing:</h3>
                        The algorithm employs OptimalF factors for capital allocation and position sizing, a dynamic
                        money
                        management technique that adjusts the position size based on the algorithm's historical
                        performance and the
                        trader's risk tolerance. By leveraging the IBKR platform's account and margin information, the
                        algorithm can
                        effectively manage its capital allocation and position sizing in real-time, optimising its
                        risk-adjusted
                        performance.
                        <br /><br />
                        <div style="text-align: center">
                            <a (click)="subBub(6)" id="AdjustableRebalance"><i
                                    class="fa-solid fa-circle-info fa-lg"></i></a>
                        </div>
                        <br />
                        In conclusion, an algorithm running on the IBKR platform that incorporates multiple criteria,
                        such as
                        timeframes, asset types, trading styles, optimisation methods, and risk management techniques,
                        can create a
                        sophisticated and robust trading system when trading assets from the S&P 500 index. The IBKR API
                        and
                        platform's tools and features, including market data access, backtesting capabilities, and risk
                        management
                        tools, facilitate the development, execution, and management of such a complex algorithm,
                        <span scrolledTo #scrolledToElement="scrolledTo"></span>
                        enabling traders
                        to capitalise on diverse market opportunities and potentially enhance their overall trading
                        performance.
                        <br /><br />
                        <h4>External Resources:</h4><br />
                        <h5>Cambridge Core:</h5>
                        Cambridge Core is a digital library that provides access to academic journals, books, and
                        reference works
                        published by Cambridge University Press. You can find research papers on algorithmic trading and
                        the S&P 500
                        market by searching for suitable keywords.
                        URL: <a href="https://www.cambridge.org/core" target="_blank"
                            rel="noopener noreferrer">https://www.cambridge.org/core</a>
                    </td>
                </tr>
            </table>
        </div>
        <br />
        <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

        <section class="linkedIn">
            <div class="shell">
                <div class="section__content">
                    <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                        rel="noopener noreferrer"><img class="linkedImg"
                            src="../../assets/img/Follow Us on LinkedIn.png" alt="Follow us on LinkedIn" /></a>
                </div>
            </div>
        </section>
    </div>
    <div [class.sticky2-mob-stop]="scrolledToElement.reached" [class.sticky2-mob]="scrolledToElement.notreached">
        <div class="row">
            <div class="col-auto" style="align-items: center;
                    display: grid;margin-left:2%">

                <i [routerLink]="['/']" fragment="bubbles" class="fa-solid fa-arrow-left fa-3x"></i>
            </div>
            <div class="col" style="width: 70%;">
                <audio controls>
                    <source src="https://theapi.cosmic-algorithm.ie/Method - Overview.mp3" type="audio/mpeg">
                    Your browser does not support the audio element.
                </audio>

            </div>
            <div class="col-auto" style="align-items: center;
            display: grid;margin-right:2%">

                <i [routerLink]="['/']" class="fa-solid fa-house fa-3x" (click)="removePos()"></i>
            </div>
        </div>

    </div>
</div>

<div *ngIf="!mobile">
    <div class="template" style="font-size:large">
        <div>
            <table>
                <tr>
                    <td style="padding-left: 2%; vertical-align: top;">
                        <div class="sticky2">
                <tr>
                    <td>
                        <audio controls>
                            <source src="https://theapi.cosmic-algorithm.ie/Method - Overview.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio><br /><br />
                    </td>
                </tr>
                <tr>
                    <td style="text-align:center;">
                        <i [routerLink]="['/']" fragment="bubbles" class="fa-solid fa-arrow-left fa-lg"></i>
                    </td>
                </tr>
                <br />
                <tr>
                    <td>
                        <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span
                            class="breadcrumbs">Methodology</span><br />
                    </td>
                </tr>
        </div>
        </td>
        <td style="width: 79%;
                                    padding-right: 19%;
                                    padding-top: 3%;
                                    padding-bottom: 3%;">
            <!-- <span class="breadcrumbs">Home</span> / <span class="breadcrumbs">Information</span> / <span class="breadcrumbs">Methodology</span><br/> -->
            <h1 style="color: #5ECE42">Method - Overview</h1><br />
            An algorithm running on the Interactive Brokers (IBKR) platform can be designed to trade a diversified
            portfolio of assets from the S&P 500 index while incorporating various criteria, such as timeframes, asset
            types, trading styles, optimisation methods, and risk management techniques.
            <br /><br />

            <h2>Here's an overview of how such an algorithm can be implemented on the IBKR platform:</h2>

            <br /><br />
            <h3>Timeframe and Data Handling:</h3>
            The algorithm operates on 4-hour bars, focusing on a medium-term timeframe. Using the IBKR API, the
            algorithm can access and process 4-hour historical and real-time bar data for the desired assets from the
            S&P 500 index. The API ensures seamless integration with the platform and provides the necessary market
            data.

            <a (click)="subBub(1)" id="DailyCandles"><i class="fa-solid fa-circle-info fa-lg"></i></a>
            <br /><br />

            <h3>Asset Selection:</h3>
            The algorithm trades a portfolio of the most liquid currencies, indices, and commodities within the S&P 500
            index. The IBKR platform offers access to a wide range of financial instruments within this index. The
            algorithm can use specific criteria, such as trading volume, bid-ask spread, or market capitalisation, to
            select the most liquid assets from each category.

            <a (click)="subBub(2)" id="AbsoluteMomentum"><i class="fa-solid fa-circle-info fa-lg"></i></a><br /><br />

            <h3>Multiple Algorithm Components:</h3>
            The algorithm incorporates 10 separate components that run in parallel, including five trend-following and
            five mean-reversion strategies. Each component targets different market conditions and price patterns,
            providing diversification and potentially enhancing the overall performance of the algorithm. The IBKR API
            enables the simultaneous execution of multiple trading strategies, allowing efficient management of these
            parallel components.

            <a (click)="subBub(3)" id="RelativeMomentum"><i class="fa-solid fa-circle-info fa-lg"></i></a>
            <br /><br />

            <h3>Rolling Window Walk-Forward Optimisation:</h3>
            To optimise the algorithm, a rolling window walk-forward optimisation method is employed over a 7-year
            period. This technique involves dividing the historical data into multiple in-sample and out-of-sample
            segments, iteratively training and testing the algorithm on these segments to fine-tune its parameters. The
            IBKR platform's backtesting capabilities support this optimisation process by providing extensive historical
            data and performance analysis tools.

            <a (click)="subBub(4)" id="StockAndEtf"><i class="fa-solid fa-circle-info fa-lg"></i></a>
            <br /><br />

            <h3>Volatility-Adjusted Trade Exit Logic:</h3>
            The algorithm uses volatility-adjusted trade exit logic, dynamically adjusting exit points based on market
            volatility. This approach helps protect profits and minimise losses during periods of high market
            volatility. The IBKR platform offers access to various volatility measures, such as the Average True Range
            (ATR) or historical volatility, which can be incorporated into the exit logic.

            <a (click)="subBub(5)" id="LeveragedAndUnleveraged"><i class="fa-solid fa-circle-info fa-lg"></i></a>
            <br /><br />

            <h3>Capital Allocation and Position Sizing:</h3>
            The algorithm employs OptimalF factors for capital allocation and position sizing, a dynamic money
            management technique that adjusts the position size based on the algorithm's historical performance and the
            trader's risk tolerance. By leveraging the IBKR platform's account and margin information, the algorithm can
            effectively manage its capital allocation and position sizing in real-time, optimising its risk-adjusted
            performance.

            <a (click)="subBub(6)" id="AdjustableRebalance"><i class="fa-solid fa-circle-info fa-lg"></i></a>

            <br /><br />
            In conclusion, an algorithm running on the IBKR platform that incorporates multiple criteria, such as
            timeframes, asset types, trading styles, optimisation methods, and risk management techniques, can create a
            sophisticated and robust trading system when trading assets from the S&P 500 index. The IBKR API and
            platform's tools and features, including market data access, backtesting capabilities, and risk management
            tools, facilitate the development, execution, and management of such a complex algorithm, enabling traders
            to capitalise on diverse market opportunities and potentially enhance their overall trading performance.

            <br /><br />
            <h4>External Resources:</h4><br />
            <h5>Cambridge Core:</h5>
            Cambridge Core is a digital library that provides access to academic journals, books, and reference works
            published by Cambridge University Press. You can find research papers on algorithmic trading and the S&P 500
            market by searching for suitable keywords.
            URL: <a href="https://www.cambridge.org/core" target="_blank"
                rel="noopener noreferrer">https://www.cambridge.org/core</a>

        </td>
        </tr>
        </table>
    </div>
    <a class="readMoreFlex" [routerLink]="['/etoro']" (click)="capturePos()">Read More - News Feed</a><br /><br />

    <section class="linkedIn">
        <div class="shell">
            <div class="section__content">
                <a href="https://www.linkedin.com/company/cosmic-algorithm-limited/" target="_blank"
                    rel="noopener noreferrer"><img class="linkedImg" src="../../assets/img/Follow Us on LinkedIn.png"
                        alt="Follow us on LinkedIn" /></a>
            </div>
        </div>
    </section>
</div>
</div>